<template>
  <div class="stuInfopage flexCloumnSingleCenter">
    <div class="form">
      <div class="cell-group-title flexStart">
        <span style="color: #1283FF">*</span>基础信息</div>
      <div class="cell-group">
        <van-field :readonly="disabled" v-model="editForm.stuName" label="姓名" required placeholder="请输入姓名"/>
        <van-field :readonly="disabled" v-model="editForm.idNumber" label="身份证号" @blur="(f)=>handleidNumber(f,editForm.idNumber)" required placeholder="请输入身份证号"/>
        <van-field readonly v-model="editForm.gender"  label="性别" required placeholder="性别"></van-field>
        <van-field readonly v-model="editForm.birth"  label="出生年月" required placeholder="出生年月"></van-field>
        <van-field :readonly="disabled" v-model="editForm.phone" label="手机号码" type="tel" required placeholder="请输入手机号"/>
        <van-field :readonly="disabled" v-model="editForm.address" label="现居地址" required placeholder="请输入家庭地址"/>
      </div>

      <div class="cell-group-title flexStart">
        <span style="color: #1283FF">*</span>报考信息
      </div>
      <div class="cell-group">
        <van-field :readonly="disabled" v-model="editForm.afterSchool" label="毕业学校" required placeholder="请输入毕业学校"/>
        <van-field :readonly="disabled" v-model="editForm.score" type="number" label="中考成绩" required placeholder="请输入中考成绩"/>
        <van-field :readonly="disabled" v-model="editForm.phone1" label="联系电话一" type="tel" required placeholder="请输入手机号"/>
        <van-field :readonly="disabled" v-model="editForm.phone2" label="联系电话二" type="tel" required placeholder="请输入手机号"/>

        <van-field label-width='8em' v-model="editForm.major01_name" readonly is-link required
                   label="3+3专业(志愿一)" placeholder="请选择3+3专业(志愿一)"
                   @click="()=>{if(!disabled){showMj1 = true}}" />
        <van-popup v-model="showMj1" round position="bottom">
          <van-cascader v-model="editForm.major01_id" title="请选择报考专业" active-color="#1989fa" :options="majors"
                        :field-names="fieldMajors" @close="showMj1 = false" @finish="onCheckMajor1" />
        </van-popup>

        <van-field label-width='8em' v-model="editForm.major02_name" readonly is-link required
                   label="3+3专业(志愿二)" placeholder="请选择3+3专业(志愿二)"
                   @click="()=>{if(!disabled){showMj2 = true}}" />
        <van-popup v-model="showMj2" round position="bottom">
          <van-cascader v-model="editForm.major02_id" title="请选择报考专业" active-color="#1989fa" :options="majors"
                        :field-names="fieldMajors" @close="showMj2 = false" @finish="onCheckMajor2" />
        </van-popup>

        <van-field label-width='8em' v-model="editForm.major11_name" readonly is-link required
                   label="中考专业(志愿一)" placeholder="请选择中考专业(志愿一)"
                   @click="()=>{if(!disabled){showMj3 = true}}" />
        <van-popup v-model="showMj3" round position="bottom">
          <van-cascader v-model="editForm.major11_id" title="请选择报考专业" active-color="#1989fa" :options="majors"
                        :field-names="fieldMajors" @close="showMj3 = false" @finish="onCheckMajor3" />
        </van-popup>

        <van-field label-width='8em' v-model="editForm.major12_name" readonly is-link required
                   label="中考专业(志愿二)" placeholder="请选择中考专业(志愿二)"
                   @click="()=>{if(!disabled){showMj4 = true}}" />
        <van-popup v-model="showMj4" round position="bottom">
          <van-cascader v-model="editForm.major12_id" title="请选择报考专业" active-color="#1989fa" :options="majors"
                        :field-names="fieldMajors" @close="showMj4 = false" @finish="onCheckMajor4" />
        </van-popup>

      </div>

    </div>
    <div v-if="!disabled" class="submitBtn flexCenter" style="background-color:#fff;">
      <div class="btn btnChange" @click="onSubmitForm">提交</div>
    </div>
    <div v-if="disabled" class="submitBtn flexCenter" style="background-color:#fff;">
      <div class="btn" @click="onModify">点击修改</div>
    </div>
    <div style="width: 100%;height: 100px;background-color:#fff;"></div>

  </div>
</template>

<script>
import {
  Toast, Dialog
} from 'vant';
import tool from './getArea'
import wx from 'weixin-js-sdk'
export default {
  // props: {
  //   tableInfo: {
  //     type:Object,
  //     default:{}
  //   },
  //   stu_id: {
  //     type:Number,
  //     default:0,
  //   },
  //   pmid: {
  //     type:Number,
  //     default:5,
  //   },
  // },
  data() {
    return {
      editForm: {
        stuName: '',
        idNumber:'',
        gender: '',
        birth:'',
        phone:'',
        address:'',

        afterSchool:'',
        score: '',
        phone1: '',
        phone2: '',
        major01_id:'',
        major01_name:'',

        major02_id:'',
        major02_name:'',

        major11_id:'',
        major11_name:'',

        major12_id:'',
        major12_name:'',
      },
      openid: null,
      disabled: false,
      pmid:5,
      stu_id:0,
      tableInfo:{},

      //专业
      majors:[],
      showMj1:false,
      showMj2:false,
      showMj3:false,
      showMj4:false,
      fieldMajors: {
        text: 'title',
        value: 'id',
        children: 'children',
      },
    }
  },
  mounted() {
    let _this = this
    $(".stuInfopage").height($(window).height())//设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh
    if (this.$route.query) {
      console.log(79, this.$route.query)
      this.stu_id = Number(this.$route.query.stu_id)
      this.pmid = Number(this.$route.query.pmid)
      _this.getList(1).then(r=>{
        _this.getMajorList()
      })
    }
  },
  methods: {
    getStuInfo(){
      let _this = this
      return new Promise(resolve => {
        this.$http.post("/api/stu_luqu_detail", {
          stu_id: _this.stu_id,
          pmid: this.pmid
        }).then(res => {
          console.log(res.data)
          if(res.data){
            _this.editForm.department = res.data.yuanxi_name
            _this.editForm.major_name = res.data.major_name
            _this.editForm.class = res.data.class_name
            _this.editForm.stuName = res.data.stu_name
            _this.editForm.gender = String(res.data.gender)
            _this.editForm.idNumber = res.data.identity_card
            _this.editForm.birth = res.data.birthday
            _this.editForm.phone = res.data.phone
            _this.editForm.phone1 = res.data.phone
            _this.editForm.phone2 = res.data.phone2
            _this.editForm.afterSchool = res.data.school_name
            _this.editForm.score = res.data.exam_score

            _this.editForm = {..._this.editForm}
            console.log(_this.editForm)
          }
          resolve()
        })
      })
    },

    getList(flag) {
      let _this = this
      return new Promise(resolve => {
        this.$http.post('/api/t_stu_check_in_table_list', {
          pmid: _this.pmid,
          stu_id: _this.stu_id
        }).then(res => {
          for (let item of res.data.data) {
            if (item.table_name.indexOf('个人信息') != -1) {
              document.title = item.table_name
              _this.tableInfo = item
              if(flag == 1){
                if (item.table_detail) {
                  let detail = JSON.parse(item.table_detail)
                  _this.editForm = Object.assign(detail)
                  _this.disabled = true
                } else {
                  _this.getStuInfo()
                  _this.disabled = false
                }
              }
              console.log(_this.editForm)
              resolve()
              return;
            }
          }
          resolve()
        })
      })
    },
    getMajorList() {
      this.$http.post("/api/app_major_list", {
        pmid: this.pmid,
        node_type: "major"
      }).then(res => {
        this.majors = res.data
        for (let item of res.data) {
          if (this.editForm.major01_id &&( this.editForm.major01_id == item.id)) {this.editForm.major01_name = item.title}
          if (this.editForm.major02_id &&( this.editForm.major02_id == item.id)) {this.editForm.major02_name = item.title}
          if (this.editForm.major11_id &&( this.editForm.major11_id == item.id)) {this.editForm.major11_name = item.title}
          if (this.editForm.major12_id &&( this.editForm.major12_id == item.id)) {this.editForm.major12_name = item.title}
        }
      })
    },
    onCheckMajor1(e) {
      this.editForm.major01_id = e.selectedOptions[0].id
      this.editForm.major01_name = e.selectedOptions[0].title
      this.showMj1 = false
    },
    onCheckMajor2(e) {
      this.editForm.major02_id = e.selectedOptions[0].id
      this.editForm.major02_name = e.selectedOptions[0].title
      this.showMj2 = false
    },
    onCheckMajor3(e) {
      this.editForm.major11_id = e.selectedOptions[0].id
      this.editForm.major11_name = e.selectedOptions[0].title
      this.showMj3 = false
    },
    onCheckMajor4(e) {
      this.editForm.major12_id = e.selectedOptions[0].id
      this.editForm.major12_name = e.selectedOptions[0].title
      this.showMj4 = false
    },
    handleidNumber(f,val){
      // console.log(val)
      if(val){
        if(!this.IsCard(val)){
          Dialog.alert({
            title: "身份证号码格式不正确，请检查！",
            showCancelButton: false,
            confirmButtonText: "确定",
            confirmButtonColor: '#1283FF',
          }).then(() => {
            console.log("点击了确认按钮噢")
          })
        }else {
          let gender = this.getGenderFromIdCard(val)
          let birth = this.getBirthdayFromIdCard(val)
          // console.log(gender,birth,location)
          this.editForm.gender = gender
          this.editForm.birth = birth
        }
      }else{
        Dialog.alert({
          title: "身份证号码不能为空，请填写！",
          showCancelButton: false,
          confirmButtonText: "确定",
          confirmButtonColor: '#1283FF',
        }).then(() => {
          console.log("点击了确认按钮噢")
        })
      }
    },
    getGenderFromIdCard: function(idCard) {
      let gender = "";
      if (idCard.length == 18) {
        if (parseInt(idCard.substr(16, 1)) % 2 == 1) {
          gender = "男";
        } else {
          gender = "女";
        }
      }

      if (idCard.length == 15) {
        if (parseInt(idCard.charAt(14) % 2 === 1)) {
          gender = "男";
        } else {
          gender = "女";
        }
      }
      return gender;
    },
    getBirthdayFromIdCard: function(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },

    IsCard(str) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(str);
    },
    checkPhone(v) {
      let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (strTemp.test(v)) {
        return true;
      }
      return false;
    },

    onSubmitForm() {
      let _this = this

      if (!this.editForm.stuName || !this.editForm.idNumber || !this.editForm.gender || !this.editForm.birth ||
          !this.editForm.phone || !this.editForm.address ) {
        Toast('请将基础信息填写完整！');
        return
      }
      if (this.editForm.phone && !_this.checkPhone(this.editForm.phone)) {
        Toast('手机号码输入格式不正确！');
        return
      }
      if (!this.editForm.afterSchool || !this.editForm.score || !this.editForm.phone1 ||!this.editForm.phone2 ||
          !this.editForm.major01_name || !this.editForm.major02_name || !this.editForm.major11_name || !this.editForm.major12_name ) {
        Toast('请将报考信息填写完整！');
        return
      }
      if (this.editForm.phone1 && !_this.checkPhone(this.editForm.phone1)) {
        Toast('联系电话一为手机号，输入格式不正确！');
        return
      }
      if (this.editForm.phone2 && !_this.checkPhone(this.editForm.phone2)) {
        Toast('联系电话二为手机号，输入格式不正确！');
        return
      }

      _this.getList(0).then(result=>{
        console.log(_this.tableInfo)
        let params = {}
        params.table_detail = JSON.stringify(_this.editForm)
        params.table_name = _this.tableInfo.table_name
        params.table_code = _this.tableInfo.table_code
        params.stu_id = this.stu_id
        params.table_type_id = _this.tableInfo.type_id
        params.pmid = this.pmid
        if(_this.tableInfo.id){
          params.id = _this.tableInfo.id
        }
        console.log(params)
        this.requestForm(params)
      })
    },
    requestForm(params) {
      let _this = this
      this.$http.post("/api/t_stu_check_in_table_edit", params).then(function (res) {
        if (res.data.id||res.data.message=='') {
          Toast('保存成功！')
          localStorage.removeItem('tableInfo')
          localStorage.removeItem('editForm')
          setTimeout(function (){
            _this.editForm = {}
            wx.miniProgram.navigateBack({
              delta: 1
            })
          },500)
          _this.preExport()

        } else {
          Toast(res.data.msg)
          _this.disabled = false
        }
      })

    },

    preExport() {
      let _this = this
      this.$http.post("/api/stu_luqu_detail", {
        stu_id: _this.stu_id,
        pmid: _this.pmid
      }).then(res => {
        console.log(res.data)
        if (res.data.class_id) {
          let params = {
            class_id: _this.editForm.class_id,
            stu_ids: _this.stu_id,
            pmid: _this.pmid,
          }
          _this.$http.post("/api/exportWord1", params).then(function (res) {})
        }

      })


    },

    onModify() {
      let curTime = new Date().getTime()
      let time1 = new Date(this.tableInfo.cdate).getTime()
      let val = curTime - time1
      this.getDuration(val).then(result => {
            console.log(result.d,result.h)
            if (result.d > 0 || result.h > 3) {
              this.disabled = false
            } else {
              Dialog.alert({
                title: "距上次提交时间小于3小时，请不要频繁修改。",
                showCancelButton: false,
                confirmButtonText: "确定",
                cancelButtonText: "关闭",
                confirmButtonColor: '#1283FF',
              }).then(() => {
                this.disabled = true
              }).catch(() => {
                console.log("点击了取消按钮噢")
              })
            }
          }
      )
      console.log(new Date(), this.tableInfo.cdate, this.tableInfo)
    },
    getDuration(my_time) {
      return new Promise(resolve => {
        var days = my_time / 1000 / 60 / 60 / 24;
        var daysRound = Math.floor(days);
        var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
        var hoursRound = Math.floor(hours);
        var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
        var minutesRound = Math.floor(minutes);
        var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
        console.log('转换时间:', daysRound + '天', hoursRound + '时', minutesRound + '分', seconds + '秒');
        var time = hoursRound + ':' + minutesRound + ':' + seconds
        let obj = {d:daysRound,h:hoursRound}
        resolve(obj)
        return time;
      })

    },
  },
}
</script>

<style lang="less" type="text/less">
.el-textarea__inner:focus {
  outline: 0;
  border-color: #1283FF !important;
}

.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-checkbox {
  margin-top: 10px;
}

.van-checkbox__icon {
  font-size: 16px;
}

.van-checkbox__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-tag--primary {
  background-color: #1283FF;
}

.van-cell--required::before {
  color: #1283FF !important;
}

.stuInfopage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #f5f5f5;

  .form {
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .cell-group-title {
      margin: 10px 0 5px 15px;
      font-size: 14px;
      color: #969799;
    }

    .cell-group {
      padding: 0 20px;
      background-color: #fff;
    }

    .topInfo {
      color: #00D1CB;
      font-size: 12px;
    }

    .item-title {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
    }

    .item-input {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px 10px 16px;
      font-size: 14px;
      color: #646566;
    }

    .item-input1 {
      color: #ee0a24;
      font-size: 12px;
      line-height: 18px;
    }

    .item-input1::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }
  }

  .submitBtn {
    padding-top: 6vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 1.4vh 0;
      width: 60%;
      text-align: center;
      background-color: #1283FF;
      color: #fff;
      font-size: 15px;
      border-radius: 6px;
    }
  }
}

</style>
